module.exports = __webpack_public_path__ + "img/t2_raf_pt_wing_bolt.prt.675fa7ab.jpg";